import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LabelType } from '@widgets/label/label.component'

@Component({
  selector: 'bdg-text-avatar',
  templateUrl: './text-avatar.component.html',
  styleUrls: ['./text-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextAvatarComponent {
  @Input()
  text: string

  @Input()
  labelType: LabelType = 'title'

  get firstCharacter() {
    return this.text?.trim()?.substring(0, 1)?.toUpperCase()
  }
}
